import { Text } from '@wyz/ui';
import { useLottie } from 'lottie-react';
import { LoadingCarAnimationData } from '~/common/loaders';
import React from 'react';
// eslint-disable-next-line @wyz/module/no-relative-import
import './tyre-search-loader.scss';

const TyreSearchLoader = ({ children }: React.PropsWithChildren) => {
  const options = {
    animationData: LoadingCarAnimationData,
    loop: true,
    autoplay: true,
  };

  const { View } = useLottie(options, { height: 400, width: 400 });
  return (
    <div className={'tyre-search-loader-container'}>
      {View}
      <div className={'tyre-search-loader-sub-text'}>
        <Text>{children}</Text>
      </div>
    </div>
  );
};

export default TyreSearchLoader;
